import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY } from '@sortlist-frontend/design-system/legacy';

export const TeamPicture = styled.div`
  img {
    height: 25rem;
    object-fit: cover;

    @media only screen and (max-width: ${BREAKPOINTS_LEGACY.xs}) {
      height: auto;
    }
  }
`;
